export default __webpack_public_path__ + "static/media/isologo.eb4c523e.svg";